import * as React from 'react';
import ShiftScheduleBlock from './shift-schedule-block';
import ShiftBlock from './shift-block';
import ShiftBindingBlock from './shift-binding-block';
import {ScheduleSettingBody} from '../../../api/types';

type ShiftScheduleSettingFormProps = {
  data: ScheduleSettingBody;
  edit: (data: ScheduleSettingBody) => void;
  init: (data: ScheduleSettingBody) => void;
};

function ShiftScheduleSettingForm({data, edit, init}: ShiftScheduleSettingFormProps) {
  return (
    <div className={'grid grid-cols-3 grow gap-x-[15px] grid-rows-[100%]'}>
      <ShiftScheduleBlock
        list={data.shiftSchedules}
        onChange={list => {
          edit({...data, shiftSchedules: list});
        }}
        selected={data.shifts
          .flatMap(s => s.shiftSchedules)
          .map(s => s.shiftScheduleId)
        }
      />
      <ShiftBlock
        shiftSchedules={data.shiftSchedules}
        shifts={data.shifts}
        selected={data.employeeSchedules.map(s => s.shift.shiftId)}
        onChange={shifts => {
          edit({...data, shifts});
        }}
      />
      <ShiftBindingBlock
        shifts={data.shifts || []}
        employeeSchedules={data.employeeSchedules || []}
        onChange={employeeSchedules => {
          edit({...data, employeeSchedules});
        }}
        onInit={employeeSchedules => {
          init({...data, employeeSchedules});
        }}
      />
    </div>
  );
}

export default ShiftScheduleSettingForm;
